// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"90e81f4c","730":"90e81f4c","859":"90e81f4c","902":"90e81f4c"}[chunkId] + ".chunk.css";
};